import Duck from 'custom-redux-ducks-ts'

export const list = new Duck('list', 'base-react')
